import { actions } from './Reducer';

export const getUsersAction = (body) => ({
  type: actions.GET_USERS_ACTION,
  payload: body,
});

export const getUserAction = (id) => ({
  type: actions.GET_USER_ACTION,
  payload: id,
});

export const createUserAction = (formData, ids, setPage) => ({
  type: actions.CREATE_USER_ACTION,
  payload: formData,
  ids,
  setPage,
});

export const updateUserAction = (id, formData) => ({
  type: actions.UPDATE_USER_ACTION,
  payload: {
    id,
    formData,
  },
});

export const updateUserProfileAction = ({ id, formData }) => ({
  type: actions.UPDATE_PROFILE_ACTION,
  payload: {
    id,
    formData,
  },
});

export const updateUserSettingsAction = (id, formData) => ({
  type: actions.UPDATE_USER_SETTINGS_ACTION,
  payload: {
    id,
    formData,
  },
});


export const checkEmailExistAction = (email) => ({
  type: actions.CHECK_EMAIL_EXIST_ACTION,
  payload: email,
});


export const changeUserPasswordAction = (body) => ({
  type:actions.CHANGE_USER_PASSWORD,
  payload: body
})

/**
 * Actions that are fired by redux-saga watchers
 */

export const getUserSuccessAction = (user) => ({
  type: actions.GET_USER_SUCCESS_ACTION,
  payload: user,
});

export const ckeckUsernameExistAction = ({ username }) => ({
  type: actions.CHECK_USERNAME_EXIST_ACTION,
  payload: {
    username,
  },
});

export const getUsersSuccessAction = (users) => ({
  type: actions.GET_USERS_SUCCESS_ACTION,
  payload: users,
});

export const createUserSuccessAction = (user) => ({
  type: actions.CREATE_USER_SUCCESS_ACTION,
  payload: user,
});

export const updateUserSuccessAction = (user) => ({
  type: actions.UPDATE_USER_SUCCESS_ACTION,
  payload: user,
});

export const checkUsernameSuccessAction = (message) => ({
  type: actions.CHECK_USERNAME_EXIST_SUCCESS_ACTION,
  payload: message,
});

export const checkEmailExistSuccessAction = (message) => ({
  type: actions.CHECK_EMAIL_EXIST_SUCCESS_ACTION,
  payload: message,
});

/**
 * Misc
 */

export const setUsersIsLoadingAction = (isLoading) => ({
  type: actions.SET_USERS_IS_LOADING,
  payload: isLoading,
});

export const setUsersCountAction = (count) => ({
  type: actions.SET_USERS_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_U_SEARCH_VALUE,
  payload: value,
});

export const setCurrentUserAction = (currentUser) => ({
  type: actions.SET_CURRENT_USER,
  payload: currentUser,
});
